import { Box, Stack, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import ArtistLogo from '../assets/ArtistLogo.svg';

const LoadingPage = () => {
    const theme = useTheme();

    return (
        <Stack justifyContent='center' alignItems='center' sx={{ minHeight: '70vh' }}>
            <Box
                sx={{
                    position: 'relative',
                    width: 160,
                    height: 160,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {/* Outer spinning ring */}
                <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1.8, repeat: Infinity, ease: 'linear' }}
                    style={{
                        position: 'absolute',
                        inset: 0,
                        borderRadius: '50%',
                        border: '2px solid transparent',
                        borderTopColor: theme.palette.primary.main,
                        borderRightColor: theme.palette.primary.main,
                    }}
                />
                {/* Inner counter-spinning ring */}
                <motion.div
                    animate={{ rotate: -360 }}
                    transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
                    style={{
                        position: 'absolute',
                        inset: 14,
                        borderRadius: '50%',
                        border: '1px solid transparent',
                        borderTopColor: `${theme.palette.primary.main}70`,
                        borderLeftColor: `${theme.palette.primary.main}70`,
                    }}
                />
                {/* Logo center */}
                <motion.img
                    src={ArtistLogo}
                    alt='Loading'
                    animate={{
                        opacity: [0.55, 1, 0.55],
                        scale: [0.93, 1, 0.93],
                    }}
                    transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut' }}
                    style={{
                        width: '62%',
                        height: '62%',
                        objectFit: 'contain',
                        filter: `drop-shadow(0 0 14px ${theme.palette.primary.main}90)`,
                    }}
                />
            </Box>
        </Stack>
    );
};

export default LoadingPage;
